export const GENDERS = [
  { label: "男性", value: "male" },
  { label: "女性", value: "female" },
  { label: "その他/未回答", value: "other" },
];
